/**
 * Константы и дефолтные значения для боевой системы
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Дефолтные статистики существа (для случайного выбора)
 */
export const DEFAULT_CREATURE_STATS = {
  hp: 100,
  attack: 10,
  defense: 10,
  speed: 10,
  energy: 100,
  critChance: 0.05
};

/**
 * Лимиты статистики (максимальные значения)
 */
export const STAT_LIMITS = {
  hp: 1000,
  attack: 100,
  defense: 100,
  speed: 100,
  energy: 200
};











